import React from 'react';
import classnames from 'classnames';

import Focusable from './Focusable';
import play_button from './assets/PLAY.png';
import reset_button from './assets/REPLAY.png'; 
import './StageControls.css';

const STAGE_CONTROL_BUTTONS = {
	PLAY: 'play',
	RESET: 'reset',
};

const StageControls = ({button=STAGE_CONTROL_BUTTONS.NONE, focus_ref=null, has_focus=false, on_select=null}) => {
	const button_div = button ? <div className="StageControls-button-positioner">
		<Focusable
			has_focus={has_focus}
			focus_ref={focus_ref}
			on_select={on_select}
		>
			<div className="StageControls-button" onClick={on_select}></div>
		</Focusable>
	</div> : null;

	return <div className="StageControls">
		<img 
			src={play_button} 
			className={classnames('StageControls-image', {'StageControls-image-hidden': button!==STAGE_CONTROL_BUTTONS.PLAY})} 
			alt="" 
		/>
		<img 
			src={reset_button} 
			className={classnames('StageControls-image', {'StageControls-image-hidden': button!==STAGE_CONTROL_BUTTONS.RESET})} 
			alt="" 
		/>
		{button_div}
	</div>
}

export {STAGE_CONTROL_BUTTONS};
export default StageControls;


// WEBPACK FOOTER //
// ./src/StageControls.js